/* GENERATED by scripts/gen-data.mjs — chapter "x-threats" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_THREATS: NodeDef = {
  "id": "x-threats",
  "tagKey": "path:x-threats.tag",
  "x": 1216,
  "y": 440,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-threats.title",
  "subKey": "path:x-threats.sub",
  "blocks": [
    {
      "id": "x-threats.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-threats.b1.title",
      "bodyKey": "path:x-threats.b1.body",
      "flowKey": "path:x-threats.b1.flow",
      "read": [
        "inj"
      ]
    },
    {
      "id": "x-threats.b2",
      "kind": "tree",
      "xp": 20,
      "titleKey": "path:x-threats.b2.title",
      "tree": {
        "qKey": "path:x-threats.b2.tree.q",
        "branches": [
          {
            "tone": "warn",
            "aKey": "path:x-threats.b2.tree.b.0.a",
            "verdictKey": "path:x-threats.b2.tree.b.0.verdict"
          },
          {
            "tone": "pass",
            "aKey": "path:x-threats.b2.tree.b.1.a",
            "verdictKey": "path:x-threats.b2.tree.b.1.verdict"
          },
          {
            "tone": "warn",
            "aKey": "path:x-threats.b2.tree.b.2.a",
            "verdictKey": "path:x-threats.b2.tree.b.2.verdict"
          }
        ]
      }
    },
    {
      "id": "x-threats.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-threats.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-threats.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-threats.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-threats.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-threats.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-threats.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-threats.b3.ex.options.2.fb"
          },
          {
            "tKey": "path:x-threats.b3.ex.options.3.t",
            "ok": false,
            "fbKey": "path:x-threats.b3.ex.options.3.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "guardrails"
};
